import axios from 'axios'
import store from '../store'

const client = axios.create({
    baseURL: process.env.VUE_APP_API_URL
})

client.interceptors.request.use(config => {
    // TODO: Move into Store
    const token = localStorage.getItem('token')
    if (token) {
        config.headers.common.Authorization = `Bearer ${token}`
    }

    return config
})

// redirect to login, when api returns 401
client.interceptors.response.use(
    ok => ok,
    err => {
        if (err.response.status === 401) {
            store.dispatch('authentication/logout')
        }

        throw err
    }
)

export default client
